import { z } from "zod";

// Schema para filtros de fecha
export const dateFilterSchema = z.object({
  type: z.enum([
    "today",
    "lastWeek",
    "currentMonth",
    "lastMonth",
    "lastThreeMonths",
    "custom",
  ]),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
});

// Schema para datos de negocio
export const businessDataSchema = z.object({
  color: z.string(),
  modality: z.string(),
  quantity: z.number(),
  percentage: z.number(),
});

// Schema para respuesta de reporte de negocio
export const businessReportSchema = z.object({
  data: z.array(businessDataSchema),
  total: z.number(),
  period: z.string(),
});

// Schema para filtros de reporte
export const reportFiltersSchema = z.object({
  dateFilter: dateFilterSchema,
  search: z.string().optional(),
});

/** Modalidad agregada en metrics/dashboard */
export const imagingMetricsModalitySchema = z.object({
  modality: z.string(),
  count: z.number(),
  percentage: z.number(),
});

/** Bucket temporal (día o mes) */
export const imagingMetricsBucketSchema = z.object({
  bucket: z.string(),
  count: z.number(),
});

/** Comparación vs período anterior */
export const imagingMetricsGrowthSchema = z.object({
  current_period_total: z.number(),
  previous_period_total: z.number(),
  previous_period: z.object({
    date_from: z.string(),
    date_to: z.string(),
  }),
  change_absolute: z.number(),
  change_percent: z.number().optional().nullable(),
});

/** Payload data de GET /api/v1/imaging/metrics/dashboard */
export const imagingMetricsDashboardDataSchema = z.object({
  institution_id: z.string(),
  date_from: z.string(),
  date_to: z.string(),
  total_studies: z.number(),
  by_modality: z.array(imagingMetricsModalitySchema),
  by_day: z.array(imagingMetricsBucketSchema),
  by_month: z.array(imagingMetricsBucketSchema),
  growth_vs_previous_period: imagingMetricsGrowthSchema,
});

/** Respuesta completa del endpoint metrics/dashboard */
export const imagingMetricsDashboardResponseSchema = z.object({
  success: z.boolean(),
  data: imagingMetricsDashboardDataSchema,
  message: z.string().optional(),
});

/** Parámetros de consulta del dashboard */
export const imagingMetricsDashboardParamsSchema = z.object({
  user_id: z.string().min(1),
  date_from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  date_to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});

// Tipos inferidos
export type DateFilter = z.infer<typeof dateFilterSchema>;
export type BusinessData = z.infer<typeof businessDataSchema>;
export type BusinessReport = z.infer<typeof businessReportSchema>;
export type ReportFilters = z.infer<typeof reportFiltersSchema>;
export type ImagingMetricsModality = z.infer<typeof imagingMetricsModalitySchema>;
export type ImagingMetricsBucket = z.infer<typeof imagingMetricsBucketSchema>;
export type ImagingMetricsGrowth = z.infer<typeof imagingMetricsGrowthSchema>;
export type ImagingMetricsDashboardData = z.infer<
  typeof imagingMetricsDashboardDataSchema
>;
export type ImagingMetricsDashboardResponse = z.infer<
  typeof imagingMetricsDashboardResponseSchema
>;
export type ImagingMetricsDashboardParams = z.infer<
  typeof imagingMetricsDashboardParamsSchema
>;
